import React from "react";
import PropTypes from "prop-types";
import upperFirst from "lodash/upperFirst";
// Note: Importing named exports in destrucutred way directly
// from the root '@material-ui/icons' will result in the code
// for every icon being included in your project,
// so is not recommended unless you configure tree-shaking.
import Add from "@material-ui/icons/Add";
import AddToQueue from "@material-ui/icons/AddToQueue";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Assessment from "@material-ui/icons/Assessment";
import Assignment from "@material-ui/icons/Assignment";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Autorenew from "@material-ui/icons/Autorenew";
import Build from "@material-ui/icons/Build";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
import Cached from "@material-ui/icons/Cached";
import CalendarToday from "@material-ui/icons/CalendarToday";
import Camera from "@material-ui/icons/Camera";
import CameraRoll from "@material-ui/icons/CameraRoll";
import CenterFocusStrong from "@material-ui/icons/CenterFocusStrong";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import CloudDownload from "@material-ui/icons/CloudDownload";
import Close from "@material-ui/icons/Close";
import Code from "@material-ui/icons/Code";
import CropFree from "@material-ui/icons/CropFree";
import Dashboard from "@material-ui/icons/Dashboard";
import DateRange from "@material-ui/icons/DateRange";
import Delete from "@material-ui/icons/Delete";
import Description from "@material-ui/icons/Description";
import DragIndicator from "@material-ui/icons/DragIndicator";
import Edit from "@material-ui/icons/Edit";
import Email from "@material-ui/icons/Email";
import Error from "@material-ui/icons/Error";
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import EventAvailable from "@material-ui/icons/EventAvailable";
import Facebook from "@material-ui/icons/Facebook";
import FileCopy from "@material-ui/icons/FileCopy";
import Gavel from "@material-ui/icons/Gavel";
import Home from "@material-ui/icons/Home";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import Language from "@material-ui/icons/Language";
import Launch from "@material-ui/icons/Launch";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import List from "@material-ui/icons/List";
import LiveHelp from "@material-ui/icons/LiveHelp";
import Menu from "@material-ui/icons/Menu";
import Mic from "@material-ui/icons/Mic";
import Pageview from "@material-ui/icons/Pageview";
import PeopleOutline from "@material-ui/icons/PeopleOutline";
import PermIdentity from "@material-ui/icons/PermIdentity";
import Person from "@material-ui/icons/Person";
import Phone from "@material-ui/icons/Phone";
import PlayArrow from "@material-ui/icons/PlayArrow";
import PlayCircleOutline from "@material-ui/icons/PlayCircleOutline";
import PlaylistAddCheck from "@material-ui/icons/PlaylistAddCheck";
import Refresh from "@material-ui/icons/Refresh";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import Search from "@material-ui/icons/Search";
import Send from "@material-ui/icons/Send";
import Settings from "@material-ui/icons/Settings";
import SettingsInputAntenna from "@material-ui/icons/SettingsInputAntenna";
import ShareRoundedIcon from '@material-ui/icons/ShareRounded';
import Stop from "@material-ui/icons/Stop";
import Sports from "@material-ui/icons/Sports";
import VideoCall from "@material-ui/icons/VideoCall";
import VideoLibrary from "@material-ui/icons/VideoLibrary";
import Warning from "@material-ui/icons/Warning";
import Youtube from "@material-ui/icons/YouTube";
import AddCircle from '@material-ui/icons/AddCircle';
import SaveIcon from '@material-ui/icons/Save';
import Info from "@material-ui/icons/Info";



const icons = {
  Add,
  AddToQueue,
  AccountCircle,
  Assessment,
  Assignment,
  ArrowBack,
  Autorenew,
  Build,
  BusinessCenter,
  Cached,
  CalendarToday,
  Camera,
  CameraRoll,
  CenterFocusStrong,
  Check,
  ChevronLeft,
  CloudDownload,
  Close,
  Code,
  CropFree,
  Dashboard,
  DateRange,
  Delete,
  Description,
  DragIndicator,
  Edit,
  Email,
  Error,
  ErrorOutlineRoundedIcon,
  EventAvailable,
  Facebook,
  FileCopy,
  Gavel,
  Home,
  KeyboardArrowUp,
  KeyboardArrowDown,
  Language,
  Launch,
  LibraryBooks,
  List,
  LiveHelp,
  Menu,
  Mic,
  Pageview,
  PeopleOutline,
  PermIdentity,
  Person,
  Phone,
  PlayArrow,
  PlayCircleOutline,
  PlaylistAddCheck,
  Refresh,
  RemoveCircle,
  Search,
  Send,
  Settings,
  SettingsInputAntenna,
  ShareRoundedIcon,
  Stop,
  Sports,
  VideoCall,
  VideoLibrary,
  Warning,
  Youtube,
  AddCircle,
  SaveIcon,
  Info,
};

const Icon = ({ className, color, name, style }) => {
  const iconName = name.split("-").reduce((acc, p) => `${acc}${upperFirst(p)}`, "");
  const ComponentIcon = icons[`${iconName}`];
  return <ComponentIcon className={className} color={color} style={style} />;
};

Icon.propTypes = {
  /**
   * Clase adicional del componente
   */
  className: PropTypes.string,
  /**
   * Color del icono
   */
  color: PropTypes.string,
  /**
   * Nombre del icono en Material UI
   */
  name: PropTypes.string,
  /**
   * Estilos del componente
   */
  style: PropTypes.object,
};

export default Icon;
